module.exports = __webpack_public_path__ + "img/Antigua and Barbuda.a269298d.svg";